import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes } from 'react';

export const TileFooter: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={clsx('flex w-full items-center justify-center gap-s pt-10 text-text-quiet', className)} {...props}>
        <svg
            aria-hidden="true"
            fill="none"
            height="10"
            viewBox="0 0 40 24"
            width="19"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clipRule="evenodd"
                d="M28.7421 5.44761C28.9174 5.14919 29.3548 5.14919 29.53 5.44761L39.2761 22.0779C39.4513 22.3763 39.2326 22.7497 38.8821 22.7497H19.3892C19.0395 22.7497 18.82 22.3763 18.9953 22.0779L28.7421 5.44761Z"
                fill="currentColor"
                fillRule="evenodd"
            />
            <path
                clipRule="evenodd"
                d="M19 14C19 18.9705 14.9705 23 10 23C5.02947 23 1 18.9705 1 14C1 9.02947 5.02947 5 10 5C14.9705 5 19 9.02947 19 14Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
        <span className="text-xxxs">cobrainer</span>
    </div>
);
